import {useEffect, useRef, useState} from "react";
import applicationService from "../service/ApplicationService";

const ApplicationOptions = () => {

    const timeout = useRef();
    const [loading, setLoading] = useState(true);
    const [options, setOptions] = useState([]);

    useEffect(() => {
        let mount = true;
        if (timeout.current) {
            clearTimeout(timeout.current)
        }
        timeout.current = setTimeout(async () => {
            try {
                const {data} = await applicationService.search({page: 0, max: 50});
                if (mount) {
                    setOptions(data);
                    setLoading(false);
                }
            } catch (e) {
                console.error(e);
            } finally {
                mount && setLoading(false);
            }
        }, 500);
        return () => {
            mount = false;
        };
    }, []);

    if (loading) {
        return <option>Yukleniyor</option>
    } else {
        return options.map((item => (
            <option key={item._id} value={item._id}>{item.name}</option>
        )));
    }
}

export default ApplicationOptions;